export const localStorageKeys = {
  IDENTITY_PROVIDER_URL: 'connect/tokens',
  USER_KEY: 'USER',
  ACCESS_TOKEN_KEY: 'access_token',
};
